import Splide from '@splidejs/splide';

(() => {
  document.querySelectorAll('.brands-slider.splide').forEach((item) => {
    const slider = new Splide(item, {
      type: 'slide',
      perPage: 10,
      perMove: 1,
      gap: 0,
      pagination: false,
      arrows: false,
      autoplay: false,
      breakpoints: {
        991: {
          perPage: 5,
        },
        768: {
          perPage: 3,
        },
      },
    });
    slider.mount();
  });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
